/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from "../runtime";
/**
 * Check if a given object implements the UserAccount interface.
 */
export function instanceOfUserAccount(value) {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    return isInstance;
}
export function UserAccountFromJSON(json) {
    return UserAccountFromJSONTyped(json, false);
}
export function UserAccountFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        uid: !exists(json, "uid") ? undefined : json.uid,
        created: !exists(json, "created")
            ? undefined
            : json.created === null
                ? null
                : new Date(json.created),
        email: json.email,
        password: !exists(json, "password") ? undefined : json.password,
        setupIncomplete: !exists(json, "setupIncomplete")
            ? undefined
            : json.setupIncomplete,
        nickname: !exists(json, "nickname") ? undefined : json.nickname,
        firstName: !exists(json, "firstName") ? undefined : json.firstName,
        lastName: !exists(json, "lastName") ? undefined : json.lastName,
        applyDemoData: !exists(json, "applyDemoData")
            ? undefined
            : json.applyDemoData,
        ip: !exists(json, "ip") ? undefined : json.ip,
        profilePicture: !exists(json, "profilePicture")
            ? undefined
            : json.profilePicture,
        inviteCode: !exists(json, "inviteCode") ? undefined : json.inviteCode,
        googleApiActive: !exists(json, "googleApiActive")
            ? undefined
            : json.googleApiActive,
        googleApiScopes: !exists(json, "googleApiScopes")
            ? undefined
            : json.googleApiScopes,
    };
}
export function UserAccountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        uid: value.uid,
        created: value.created === undefined
            ? undefined
            : value.created === null
                ? null
                : value.created.toISOString(),
        email: value.email,
        password: value.password,
        setupIncomplete: value.setupIncomplete,
        nickname: value.nickname,
        firstName: value.firstName,
        lastName: value.lastName,
        applyDemoData: value.applyDemoData,
        ip: value.ip,
        profilePicture: value.profilePicture,
        inviteCode: value.inviteCode,
        googleApiActive: value.googleApiActive,
        googleApiScopes: value.googleApiScopes,
    };
}
